export default __webpack_public_path__ + "static/media/Slider-3.4fbfc204.jpg";